/* eslint-disable @typescript-eslint/no-unused-vars */
import { useRecoilState, useSetRecoilState } from 'recoil'
import * as atoms from 'src/atoms/user-lists-layer'
import { Colors } from 'src/components/theme'

const DEFAULT_RADIUS_RINGS: [number, number, number] = [1, 3, 5]
const DEFAULT_RINGS_ENABLED: [boolean, boolean, boolean] = [true, true, true]

export const PIN_COLORS = [
  Colors.blueDark,
  Colors.primaryRed400,
  Colors.primaryYellow400,
  Colors.primaryGreen400,
  'rgba(255, 221, 156, 1)',
  'rgba(160, 80, 222, 1)',
]

export const useMapExplorerUserLists = () => {
  const [selectedUserListIds, setSelectedUserListId] = useRecoilState(atoms.selectedUserListIds)
  const setShowLocationsPins = useSetRecoilState(atoms.showLocationsPins)
  const setShowRadiusRings = useSetRecoilState(atoms.showRadiusRings)
  const setRadiusRings = useSetRecoilState(atoms.radiusRings)
  const setRadiusRingsEnabled = useSetRecoilState(atoms.radiusRingsEnabled)
  const setRadiusRingsFillColors = useSetRecoilState(atoms.radiusRingsFillColors)
  const [pinsColor, setPinsColor] = useRecoilState(atoms.pinsColor)

  const addUserList = (id: string) => {
    if (selectedUserListIds.includes(id)) {
      return
    }

    const availableColor =
      Object.values(PIN_COLORS).find((color) => !Object.values(pinsColor).includes(color)) ?? PIN_COLORS[0]

    setSelectedUserListId((prev) => [...prev, id])
    setShowLocationsPins((prev) => {
      return {
        ...prev,
        [id]: true,
      }
    })
    setPinsColor((prev) => {
      return {
        ...prev,
        [id]: availableColor,
      }
    })
    setShowRadiusRings((prev) => {
      return {
        ...prev,
        [id]: false,
      }
    })
    setRadiusRings((prev) => {
      return {
        ...prev,
        [id]: DEFAULT_RADIUS_RINGS,
      }
    })
    setRadiusRingsEnabled((prev) => {
      return {
        ...prev,
        [id]: DEFAULT_RINGS_ENABLED,
      }
    })

    setRadiusRingsFillColors((prev) => {
      return {
        ...prev,
        [id]: [availableColor, availableColor, availableColor],
      }
    })
  }

  const removeUserList = (id: string) => {
    if (!selectedUserListIds.includes(id)) {
      return
    }

    setSelectedUserListId((prev) => prev.filter((pid) => pid !== id))
    setShowLocationsPins((prev) => {
      const { [id]: _, ...rest } = prev
      return rest
    })
    setPinsColor((prev) => {
      const { [id]: _, ...rest } = prev
      return rest
    })
    setShowRadiusRings((prev) => {
      const { [id]: _, ...rest } = prev
      return rest
    })
    setRadiusRings((prev) => {
      const { [id]: _, ...rest } = prev
      return rest
    })
    setRadiusRingsEnabled((prev) => {
      const { [id]: _, ...rest } = prev
      return rest
    })
    setRadiusRingsFillColors((prev) => {
      const { [id]: _, ...rest } = prev
      return rest
    })
  }

  return { addUserList, removeUserList }
}
